import { RemoteUpdatePerson } from 'data/usecases';
import { makeApiUrlPerson } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteUpdatePerson = (): RemoteUpdatePerson => {
  return new RemoteUpdatePerson(makeApiUrlPerson(), makeAxiosHttpClient());
};
